// extracted by mini-css-extract-plugin
export var tosLink = "_am-0";